import { css } from '@emotion/react';

import { Flex, GridItem } from '@toolbox/components';
import { makeStyles } from '@toolbox/style';
import { USPItem } from './USPItem';

import type { USPItemProps } from './USPItem';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

type FooterProps = {
  items: USPItemProps[] | undefined | null;
};

const useStyles = makeStyles(({ theme }) => ({
  root: css`
    display: none;

    ${theme.media.up('sm')} {
      display: flex;
    }
  `,
  gridItem: css`
    margin: auto;
  `,
}));

export const Footer: ReactFCWithChildren<FooterProps> = ({ items }) => {
  const classes = useStyles();

  return (
    <GridItem sm={11} md={8} grow={1} css={classes.gridItem as any}>
      <Flex css={classes.root as any} alignItems={'center'} justifyContent={'center'}>
        {items?.map((props, index) => (
          <USPItem key={index} {...props} />
        ))}
      </Flex>
    </GridItem>
  );
};
